import Vue from 'vue'
import starfish from '../static/lib/starfish/starfish.min'
import en from '../static/lib/starfish/locale/lang/en'
import '../static/lib/starfish/starfish-ui.css'
import './plugins/element.js'
import 'element-ui/lib/theme-chalk/index.css'

import VueLoading from 'vuex-loading'
// 公共样式
import './style/common.styl'

import App from './App'
// 路由配置和vuex
import store from './store'
import router from './router'
// axios
import './js/http'
// mock数据
// import './mock/mock';
// 插件
import commonUtils from '@common/js/utils'
import utils from './js/utils'

import loading from '@/components/loading.vue'
import zTable from '@common/components/z-table/fixed-table'
import zCell from '@common/components/z-table/align-cell'
import customA from '@/components/custom-a'
import commonRow from '@/components/commonRow'
import commonSelect from '@/components/commonSelect'
import commonTextarea from '@/components/commonTextarea'
import commonUrlTextarea from '@/components/commonUrlTextarea'
import commonInput from '@/components/commonInput'
import switchDropdown from '@/components/switchDropdown'
import commonBtn from '@/components/commonBtn'
import VueClipboard from 'vue-clipboard2'
import disabledTips from '@/components/disabledTips'

Vue.component('loading', loading)
Vue.component('zTable', zTable)
Vue.component('zCell', zCell)
Vue.component('customA', customA)
Vue.component('commonRow', commonRow)
Vue.component('commonSelect', commonSelect)
Vue.component('commonTextarea', commonTextarea)
Vue.component('CommonUrlTextarea', commonUrlTextarea)
Vue.component('commonInput', commonInput)
Vue.component('switchDropdown', switchDropdown)
Vue.component('commonBtn', commonBtn)
Vue.component('disabledTips', disabledTips)

Vue.use(VueLoading)
Vue.use(VueClipboard)

Vue.config.productionTip = false

Vue.use(starfish, {
  locale: en,
})

Vue.config.lang = 'en'
Vue.use(commonUtils)
Vue.use(utils)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App },
  vueLoading: new VueLoading({ registerComponents: true }),
})
